import type {
  BaseDims,
  TrackingPayload,
} from '@src/Tracking/catalog';
import {
  getDeviceId,
  getSessionId,
  getUserId,
  newEventId,
} from './identity';
import {derivePageGroup, derivePageName} from './pageGroup';

/**
 * Auto-fills BaseDims on every event. Existing values on the payload win.
 */
export function enrichEvent(
  event: string,
  payload?: TrackingPayload,
): TrackingPayload & Required<Pick<BaseDims, 'event_id' | 'event_time'>> {
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';

  const base: Partial<BaseDims> = {
    event_id: newEventId(),
    event_time: new Date().toISOString(),
    user_id: getUserId(),
    device_id: getDeviceId(),
    session_id: getSessionId(),
    platform: 'web',
    locale: typeof navigator !== 'undefined' ? navigator.language : undefined,
    page: pathname,
    page_group: pathname ? derivePageGroup(pathname) : undefined,
  };

  return {
    ...base,
    ...(payload ?? {}),
    // event_id + event_time always overwrite any incoming values — they are
    // emitter-controlled identifiers.
    event_id: newEventId(),
    event_time: new Date().toISOString(),
  } as TrackingPayload & Required<Pick<BaseDims, 'event_id' | 'event_time'>>;
}

export {derivePageGroup, derivePageName};
